import { render, staticRenderFns } from "./abnormalWords.vue?vue&type=template&id=19a025c7&scoped=true"
import script from "./abnormalWords.vue?vue&type=script&lang=js"
export * from "./abnormalWords.vue?vue&type=script&lang=js"
import style0 from "./abnormalWords.vue?vue&type=style&index=0&id=19a025c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a025c7",
  null
  
)

export default component.exports